import { OffboardComponent } from "src/app/models/dto/offboardComponent";
import { GraphQLOffboardComponentOutput } from "../models/output/graphql-offboard-component-output";

  export function convertGraphqlOffboardComponentToDto(input: GraphQLOffboardComponentOutput): OffboardComponent {
    return {
      uid: input.Uid,
      name: input.Name,
    }
  }
